<template>
  <span
    class="gh-svg-icon"
    :style="iconStyle"
    aria-hidden="true"
  />
</template>

<script>
export default {
  name: 'GenerationHistorySvgIcon',
  props: {
    src: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconStyle() {
      const style = {
        WebkitMaskImage: `url(${this.src})`,
        maskImage: `url(${this.src})`,
      };
      if (this.color) {
        style.color = this.color;
      }
      return style;
    },
  },
};
</script>
